import { GetUserResponse } from "../../proto/api_pb";
import { registerUser } from "../../services/registerUserService";

export const secondsToMinutes = (seconds: number): string | null => {
  if (seconds === 0) {
    return null; // Return null if seconds is 0
  }

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds} mins | `;
};


export const formatTime = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

export const getTimestampToDate = (timeStamp: number, isExpiryTime?: boolean): string => {
  const date = isExpiryTime
    ? new Date(timeStamp)
    : new Date(timeStamp * 1000);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const amPm = hours >= 12 ? "PM" : "AM";
  const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  return `${month}/${day}/${year} ${formattedHours}:${formattedMinutes} ${amPm}`;
};

export async function handleUpdateFreeTierMetadata({
  userId,
  token,
  awsAccessKeyId,
  awsSecretAccessKey,
  awsSessionToken,
  masteringCount,
  tracksUploaded,
  user
}: {
  userId: string;
  token: string;
  awsAccessKeyId: string | undefined;
  awsSecretAccessKey: string | undefined;
  awsSessionToken: string | undefined;
  masteringCount: number;
  tracksUploaded: number;
  user: GetUserResponse
}): Promise<void> {
  const profile = {
    firstName: user.getFirstName(),
    lastName: user.getLastName(),
    username: user.getUsername(),
    email: user.getEmail(),
    bio: user.getBio(),
    connectedWallet: "",
    skills: user.getSkillsList(),
    genres: user.getSkillsList(),
    profilePic: user.getProfilePicture() ?? "",
  };

  await registerUser(
    profile,
    null,
    userId,
    user,
    null,
    token,
    awsAccessKeyId,
    awsSecretAccessKey,
    awsSessionToken,
    user.getEnterpriseDetailsList(),
    masteringCount,
    tracksUploaded
  );
}
